import {
    useEffect,
    type FC
} from "react";
import {
    View
} from "react-native";
import type IDataTablePaginationProps from "./type";
import stylesheet, {
    useStyles
} from "./stylesheet";
import {
    NCoreUIKitTheme
} from "../../../../core/hooks";
import {
    useDataTableContext
} from "../../context";
import PaginationRoot from "../../../pagination";

const DataTablePagination: FC<IDataTablePaginationProps> = ({
    customTheme: customThemeProp,
    pageSizeOptions,
    unitTitle,
    style,
    ...props
}) => {
    const context = useDataTableContext({
        part: "Pagination"
    });

    const {
        borders,
        colors,
        spaces
    } = NCoreUIKitTheme.useContext(customThemeProp ?? context?.customTheme);

    const {
        container: containerDynamicStyle,
        more: moreDynamicStyle,
        end: endDynamicStyle
    } = useStyles({
        borders,
        colors,
        spaces
    });

    const registerPagination = context?.registerPagination;

    useEffect(() => {
        return registerPagination?.();
    }, [
        registerPagination
    ]);

    if(!context || context.isPermissionDenied || context.error) {
        return null;
    }

    const currentTheme = customThemeProp ?? context.customTheme;

    if(context.layout === "cards") {
        return <PaginationRoot
            onLoadMore={() => context.handlePageChange(context.page + 1)}
            customLocalize={context.customLocalize}
            loadedCount={context.rows.length}
            totalItems={context.totalCount}
            isLoading={context.isLoading}
            customTheme={currentTheme}
            unitTitle={unitTitle}
            style={[
                style,
                moreDynamicStyle
            ]}
            variant="loadMore"
        />;
    }

    return <View
        {...props}
        style={[
            style,
            containerDynamicStyle
        ]}
    >
        <PaginationRoot
            onPageSizeChange={context.handlePageSizeChange}
            onPageChange={context.handlePageChange}
            customLocalize={context.customLocalize}
            pageSizeOptions={pageSizeOptions}
            totalItems={context.totalCount}
            isDisabled={context.isLoading}
            pageSize={context.pageSize}
            customTheme={currentTheme}
            unitTitle={unitTitle}
            page={context.page}
            size="small"
        >
            <PaginationRoot.Range
                customTheme={currentTheme}
            />
            <View
                style={[
                    stylesheet.end,
                    endDynamicStyle
                ]}
            >
                <PaginationRoot.PageSize
                    customTheme={currentTheme}
                />
                <PaginationRoot.Content
                    customTheme={currentTheme}
                />
            </View>
        </PaginationRoot>
    </View>;
};
export default DataTablePagination;
